import { NumberFormatter } from "@mantine/core";

export const ListItem = ({
    title,
    value,
    showPrefix = false,
}: {
    title: string;
    value: number;
    showPrefix?: boolean;
}) => {
    return (
        <div className="flex items-center gap-2 w-full border-b border-gray-400 py-1.5 last:border-b-0">
            <div className="flex-1 text-slate-800">{title}</div>
            <div className="text-right font-medium">
                <NumberFormatter
                    thousandSeparator
                    prefix={showPrefix ? "₹ " : ""}
                    value={value}
                />
            </div>
        </div>
    );
}